import { memo, useMemo } from 'react';

import moment from 'moment';
import pathToRegexp from 'path-to-regexp';
import { Link } from 'react-router-dom';

import type { WorkflowGroupsQueryQuery } from '@/apollo/graphql';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import { ROUTE_GROUP_SETTINGS } from '@/constant/routes';
import { pluralize } from '@/utils';
import { getGroupCounts } from './utils';

type Props = {
  group: NonNullable<
    NonNullable<
      WorkflowGroupsQueryQuery['workflowByRowId']
    >['groups']['nodes'][number]
  >;
};
/**
 * A single group card linking to the group's page
 */
export const GroupCard = memo(({ group }: Props) => {
  const { teams, users, bots } = useMemo(
    () => getGroupCounts(group.members.nodes),
    [group.members.nodes]
  );

  return (
    <Link
      className="group grid grid-cols-5 gap-2 overflow-hidden rounded-md border border-border bg-card px-5 py-2 text-muted-foreground hover:border-input hover:bg-card-hover"
      to={pathToRegexp.compile(ROUTE_GROUP_SETTINGS)({ id: group.rowId })}
    >
      <div className="col-span-3 flex h-full flex-row flex-nowrap items-center gap-3">
        <AvatarComponent name={group.name} source={group.avatar} />
        <div className="flex flex-col flex-nowrap items-start truncate text-foreground text-sm capitalize">
          {group.name}
        </div>
      </div>
      <div className="flex h-full items-center justify-end text-xs sm:mt-0">
        {`Created on ${moment(group.createdAt).format('dddd, Do MMMM YYYY')}`}
      </div>
      <div className="flex h-full items-center justify-end text-xs sm:mt-0">
        {pluralize(users + bots, 'participant', false, true)},{' '}
        {pluralize(teams, 'team', false, true)}
      </div>
    </Link>
  );
});
